document.addEventListener('DOMContentLoaded', () => {
    const sliderButtons = document.querySelectorAll('.estimare__button');

    sliderButtons.forEach((button) => {
        const handle = button.querySelector('.estimare__button-handle');
        const label = button.querySelector('.estimare__button-label');

        if (!handle || !label) return;

        let isDragging = false;
        let startX = 0;
        let startPosition = 0;
        let currentPosition = 0;

        const getMaxPosition = () => {
            const buttonWidth = button.getBoundingClientRect().width;
            const handleWidth = handle.getBoundingClientRect().width;
            const handleLeft = parseFloat(window.getComputedStyle(handle).left) || 0;
            const rightGap = 15;

            return Math.max(
                0,
                buttonWidth - handleWidth - rightGap - handleLeft
            );
        };

        const setPosition = (position, animate = false) => {
            currentPosition = Math.max(0, Math.min(position, getMaxPosition()));
            button.classList.toggle('is-dragging', !animate && isDragging);
            button.style.setProperty(
                '--estimare-slider-position',
                `${currentPosition}px`
            );
        };

        const complete = () => {
            isDragging = false;
            button.classList.remove('is-dragging');
            button.classList.add('is-complete');
            button.setAttribute('aria-pressed', 'true');
            button.setAttribute('aria-label', 'Book an expert');
            label.textContent = 'Book an expert';
            setPosition(getMaxPosition(), true);
        };

        const reset = () => {
            isDragging = false;
            button.classList.remove('is-dragging');
            setPosition(0, true);
        };

        handle.addEventListener('pointerdown', (event) => {
            if (button.classList.contains('is-complete')) return;

            isDragging = true;
            startX = event.clientX;
            startPosition = currentPosition;
            button.classList.add('is-dragging');
            handle.setPointerCapture(event.pointerId);
            event.preventDefault();
        });

        handle.addEventListener('pointermove', (event) => {
            if (!isDragging) return;

            setPosition(startPosition + event.clientX - startX);
            event.preventDefault();
        });

        const finishDrag = (event) => {
            if (!isDragging) return;

            if (handle.hasPointerCapture(event.pointerId)) {
                handle.releasePointerCapture(event.pointerId);
            }

            if (currentPosition >= getMaxPosition() * 0.85) {
                complete();
            } else {
                reset();
            }
        };

        handle.addEventListener('pointerup', finishDrag);
        handle.addEventListener('pointercancel', reset);

        button.addEventListener('click', (event) => {
            event.preventDefault();
        });

        button.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;

            event.preventDefault();
            complete();
        });

        window.addEventListener('resize', () => {
            if (button.classList.contains('is-complete')) {
                setPosition(getMaxPosition(), true);
            }
        });
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/estimare.js